import React from 'react';
import Navigation from './Navigation';
import { NavLink } from 'react-router-dom';
import '../../styles/common/Header.css';

class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = { 
            logoIcon: require('./../../images/logo-icon.png'),
            bsCladsLogo: require('./../../images/bs-clads-logo.png'),
            isScrolled: false,
            isNavOpen: false
        };
    }

    closeNav = () => {
        this.setState({ isNavOpen: false });
    };

    toggleNav = () => {
        this.setState(prevState => ({ isNavOpen: !prevState.isNavOpen }));
    };

    componentDidMount() {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset >= 50) {
                this.setState({ isScrolled: true });
            } else {
                this.setState({ isScrolled: false });
            }
        }

        handleScroll();
        window.addEventListener('scroll', handleScroll);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.isNavOpen) {
            document.body.classList.add('mobile-nav-open');
            document.body.style.overflow = 'hidden';
        } else {
            document.body.classList.remove('mobile-nav-open');
            document.body.style.overflow = 'unset';
        }
    }

    componentWillUnmount() {
        document.body.style.overflow = 'unset';
        document.body.classList.remove('mobile-nav-open');
    }

    render() {
        const isScrolled = this.state.isScrolled;
        const isNavOpen = this.state.isNavOpen;

        return (
            <>
                {isNavOpen && <div className="mobile-nav-backdrop" onClick={this.closeNav} />}
                <header
                    className={`site-header nav-wide mobile-sider-drawer-menu ${isNavOpen ? 'active mobile-nav-open' : ''} ${isScrolled ? 'site-header-scrolled' : 'site-header-dark'}`}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        zIndex: 999999,
                        backgroundColor: isScrolled ? '#ffffff' : '#111111',
                        boxShadow: isScrolled ? '0 4px 20px rgba(0,0,0,0.12)' : 'none',
                        transition: 'background-color 0.35s ease, box-shadow 0.35s ease',
                        height: '80px'
                    }}
                >
                    <div className="sticky-header main-bar-wraper navbar-expand-lg" style={{ width: '100%', height: '80px', background: 'transparent' }}>
                        <div className="main-bar" style={{ paddingLeft: '25px', paddingRight: '25px', height: '80px', background: 'transparent', display: 'flex', alignItems: 'center' }}>
                            <div className="container-fluid clearfix" style={{ paddingLeft: 0, paddingRight: 0, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                
                                {/* LOGO HEADER */}
                                <div className="logo-header" style={{ width: 'auto', display: 'flex', alignItems: 'center', height: '80px', margin: 0, padding: 0, float: 'none' }}>
                                    <div className="logo-header-inner logo-header-one" style={{ paddingLeft: 0, display: 'flex', alignItems: 'center', height: '80px' }}>
                                        <NavLink to={"/"} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ display: 'inline-flex', alignItems: 'center', gap: '12px', textDecoration: 'none', height: '80px' }}>
                                            <img src={this.state.logoIcon} alt="BS Icon" style={{ height: '42px', width: 'auto', objectFit: 'contain', margin: 0 }} />
                                            <img src={this.state.bsCladsLogo} alt="bs clads" style={{ height: '42px', width: 'auto', objectFit: 'contain', margin: 0 }} />
                                        </NavLink>
                                    </div>
                                </div>

                                 {/* NAV TOGGLE BUTTON FOR MOBILE */}
                                 <button
                                     id="mobile-side-drawer"
                                     type="button"
                                     className={`navbar-toggler ${isNavOpen ? 'active' : 'collapsed'}`}
                                     onClick={this.toggleNav}
                                     aria-label="Toggle navigation"
                                     style={{ background: 'none', border: 'none', padding: '6px' }}
                                 >
                                     <i className={isNavOpen ? "fa fa-times" : "fa fa-bars"} style={{ fontSize: '24px', color: isScrolled ? '#111111' : '#ffffff', transition: 'color 0.35s ease' }} />
                                 </button>

                                {/* MAIN NAVIGATION */}
                                <div className={`header-nav nav-dark navbar-collapse ${isNavOpen ? 'show active' : 'collapse'} justify-content-center`}>
                                    <Navigation
                                        isScrolled={isScrolled}
                                        toggleNav={this.toggleNav}
                                        closeNav={this.closeNav}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </>
        );
    };
};

export default Header;
